import {Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import {
  ChartTemplateService,
  ChartType,
  Xaxis,
  Yaxis
} from '../../../../cockpit/cockpit-shared/charts-templates/chart-template.service';
import {ChartsM2} from 'shared/dtos/cockpit/charts/charts';
import {Risikopaare} from 'shared/dtos/cockpit/risikopaare';
import {DataStorageService} from 'shared/services/data-storage.service';
import {CockpitChartComponent} from '../../../cockpit-shared/cockpit-content-component';

@Component({
  selector: 'app-chart-dialog-risikopaare',
  templateUrl: './chart-dialog-risikopaare.component.html',
  styleUrl: './chart-dialog-risikopaare.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartDialogRisikopaareComponent
  extends CockpitChartComponent
  implements OnInit
{
  private risikopaare: Risikopaare;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly dataStorageService: DataStorageService,
    private readonly translateService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.dataStorageService.getChartsData().then((data: ChartsM2) => {
      this.risikopaare = data.risikopaare;
      this.initialize(this.risikopaare);
    });

    this.translateService.onLangChange.subscribe(() => {
      const svgContainer = document.getElementById('svgContenairRisikopaare');
      if (svgContainer) {
        this.initialize(this.risikopaare);
      }
    });
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  initialize(data: Risikopaare) {
    this.chartTemplateService.chartname = 'risikopaare';
    const series = JSON.parse(data.series);

    if (series) {
      series.forEach((property: any) => {
        if (property.name) {
          property.name = this.translateService.instant(property.name);
        }
      });
    }

    const chartType = {
      type: 'scatter'
    } as ChartType;

    const chartTitle = {
      text: this.translateService.instant(
        'm2.sprint5.cockpit.card.chart.kennzahlenDerMethodik.title'
      ),
      style: {color: '#333333', fontSize: '16px'}
    };

    const xAxis = {
      min: 10,
      max: 50,
      title: {
        text: this.translateService.instant(
          'm2.sprint5.cockpit.card.chart.kennzahlenDerMethodik.x-Achse'
        )
      }
    } as unknown as Xaxis;

    const yAxis = {
      min: 10,
      max: 50,
      title: {
        text: this.translateService.instant(
          'm2.sprint5.cockpit.card.chart.kennzahlenDerMethodik.y-Achse'
        )
      }
    } as unknown as Yaxis;

    const legend = {reversed: false};
    const tooltip = {
      pointFormat: ``
    };

    this.chartTemplateService.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      null,
      tooltip,
      chartType
    );

    Highcharts.chart(
      'svgContenairRisikopaare',
      this.chartTemplateService.json,
      thechart => {
        this.callBackFuncToNormalizeBarChart(thechart);

        const resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.reflow();
          }
        });
        resizeObserver.observe(
          document.getElementById('svgContenairRisikopaare')
        );
      }
    );
  }

  private callBackFuncToNormalizeBarChart(thechart: Highcharts.Chart) {
    this.chart = thechart;
    thechart.setSize();
  }
}
